import { siteConfig } from "@/config/site";
import { useLocale } from "@/i18n/locale-context";
import type { LocaleContent, SharedSiteConfig } from "@/types/site";

export function useSiteContent(): LocaleContent {
  const { messages } = useLocale();
  return messages.content;
}

export function useSiteShared(): SharedSiteConfig {
  return siteConfig.shared;
}

export { siteConfig };
